import React, { Component } from 'react';
import { Container } from 'reactstrap';
import { NavMenu } from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render () {
    return (
        <div style={{height: "100%", width: "100%"}} >
          {this.props.children}
      </div>
    );
  }
}
